<template>
	<div style="{'border-radius': '8px 8px 0 0'}">
		<attach-image-dialog @selected="updateImage" ref="attachments" />
		<div class="background-img-container">
			<v-img
				v-if="!profileData.background"
				src="@/assets/images/sou-bg.png"
				lazy-src="@/assets/images/image-placeholder.jpg"
				height="230"
				:style="{ 'border-radius': '8px 8px 0 0' }"
			></v-img>
			<v-img
				v-else
				:src="profileData.background.url"
				lazy-src="@/assets/images/image-placeholder.jpg"
				height="230"
				:style="{ 'border-radius': '8px 8px 0 0' }"
			></v-img>

			<v-overlay
				class="avatar-wrapper"
				color="background lighten-1"
				absolute="absolute"
				:value="true"
				:opacity="1"
				z-index="1"
			>
				<avatar
					:key="profileData.id"
					:user="profileData"
					:bg="true"
					:hideActivity="true"
					:isRoute="false"
				/>
			</v-overlay>

			<v-overlay
				class="change-img-wrapper"
				absolute="absolute"
				:value="true"
				:opacity="0"
				z-index="1"
			>
				<v-btn
					v-if="profileData.id === user.id"
					@click="$refs.attachments.dialog = true"
					color="grey lighten-2"
					height="32"
					elevation="0"
					:style="{ 'font-size': '12px' }"
				>
					<v-icon class="mr-1"> $camera </v-icon>
					{{ $vuetify.lang.t("$vuetify.views.profile.changePhoto") }}
				</v-btn>
			</v-overlay>
		</div>
		<div class="card">
			<div>
				<div class="d-flex justify-space-between retraction pt-6 pr-6">
					<div>
						<div
							class="font-16 grey--text text--darken-1 font-weight-bold"
						>
							{{ profileData.name || profileData.email }}
						</div>
						<div class="grey--text">
							{{
								profileData.team
									? profileData.team.name || ""
									: ""
							}}
						</div>
					</div>
					<!-- <v-btn height="32" elevation="0">Więcej</v-btn> -->
				</div>

				<div class="d-flex justify-space-around mt-9 mb-10">
					<div class="d-flex">
						<v-icon>$star</v-icon>
						<div class="ml-2">
							<div class="number grey--text text--darken-2">
								{{ profileData.trainingsCount || 0 }}
							</div>
							<div class="grey--text font-weight-medium font-12">
								{{
									$vuetify.lang.t(
										"$vuetify.views.profile.completedTrainings"
									)
								}}
							</div>
						</div>
					</div>

					<div class="d-flex">
						<v-icon>$certificate</v-icon>
						<div class="ml-2">
							<div class="number grey--text text--darken-2">
								{{ profileData.certificatesCount || 0 }}
							</div>
							<div class="grey--text font-weight-medium font-12">
								{{
									$vuetify.lang.t(
										"$vuetify.views.profile.certificates"
									)
								}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar";
import AttachImageDialog from "@/components/wall/dialogs/AttachImageDialog";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
	components: {
		Avatar,
		AttachImageDialog,
	},

	props: {
		profileData: {
			type: Object,
		},
	},

	data() {
		return {
			isBackgroundLoading: false,
		};
	},

	computed: {
		...mapGetters({ user: "auth/user" }),
	},

	methods: {
		async updateImage(img) {
			let res;

			this.isBackgroundLoading = true;

			if (this.profileData.background) {
				res = await this.deleteAvatar(true);
			}

			if (!this.profileData.background || res.success) {
				res = await this.postImage(encodeURIComponent(img));
			}

			res = await this.setBackground(res.data.token);
		},

		async postImage(img) {
			let res;
			await axios
				.post(`files`, {
					type: "image",
					for: "user_background",
					file: img,
				})
				.then((response) => {
					res = {
						success: true,
						data: response.data.data,
					};
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};
				});
			return res;
		},

		async deleteAvatar(isUpdate) {
			let res;
			await axios
				.post("users/manage-files", { delete_background: true })
				.then(() => {
					res = {
						success: true,
					};

					this.profileData.background = null;
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};

					if (!isUpdate) {
						this.isError = true;
					}
				});
			return res;
		},

		async setBackground(token) {
			let res;
			await axios
				.post("users/manage-files", { background_token: token })
				.then((response) => {
					res = {
						success: true,
					};

					this.profileData.background = {
						url: response.data.data[1].url,
					};
					this.isBackgroundLoading = false;
				})
				.catch((error) => {
					res = {
						success: false,
						error: error,
					};
				});
			return res;
		},
	},
};
</script>

<style lang="scss" scoped>
.background-img-container {
	height: 230px;
	position: relative;
	background: white;

	span.v-btn__content {
		color: var(--v-grey-darken1) !important;
	}
}

.no-background {
	height: 230px;
	width: 100%;
	background: var(--v-grey-lighten4);
}

.card {
	background: var(--v-background-lighten1);
	border: 1px solid var(--v-grey-lighten4);
	border-top: none;
	border-bottom-right-radius: 8px;
	border-bottom-left-radius: 8px;
}

.avatar-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 150px;
	height: 150px;
	position: absolute;
	top: 155px;
	left: 36px;
	border-radius: 100%;
}

.change-img-wrapper {
	width: 158px;
	height: 32px;
	position: absolute;
	top: 16px;
	left: 100%;
	transform: translateX(-105%);
}

.img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-top-left-radius: 8px;
	border-top-right-radius: 8px;
}

.retraction {
	padding-left: 198px;
}

.number {
	font-size: 16px;
	font-weight: 500;
}
</style>
